// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail--vV1oUtlK2","changed":"changed--3fefcRoSP"};